var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"disabled":!_vm.enablePlayButton,"large":"","color":"red darken-3","fab":""},on:{"click":function($event){return _vm.$emit('onStart')}}},[_c('v-icon',[_vm._v("play_arrow")])],1),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.enableStopButton,"large":"","color":"blue darken-3","fab":""},on:{"click":function($event){return _vm.$emit('onStop')}}},[_c('v-icon',[_vm._v("stop")])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2352743e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/live/StreamingControls.vue
// module id = 672
// module chunks = 0